import { useEffect, useRef, useState } from 'react';

const items = [
  { icon: 'ri-star-fill', text: 'Trusted by OEMs & Agencies' },
  { icon: 'ri-earth-line', text: 'Serving All 50 States' },
  { icon: 'ri-award-line', text: '20+ Years of Experience' },
  { icon: 'ri-shield-star-line', text: 'White-Glove Execution' },
  { icon: 'ri-calendar-event-line', text: 'Auto Show Specialists' },
  { icon: 'ri-car-line', text: 'Fleet Program Experts' },
  { icon: 'ri-focus-3-line', text: 'Zero-Compromise Quality' },
  { icon: 'ri-building-4-line', text: 'National Crew Network' },
];

export default function TrustBar() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.2 });
    if (scrollRef.current) obs.observe(scrollRef.current);
    return () => obs.disconnect();
  }, []);

  const doubled = [...items, ...items];

  return (
    <section
      ref={scrollRef}
      className={`py-5 border-y border-gold/15 overflow-hidden transition-opacity duration-700 ${visible ? 'opacity-100' : 'opacity-0'}`}
      style={{ background: 'linear-gradient(90deg, #0e0e0e 0%, #161410 50%, #0e0e0e 100%)' }}
    >
      <div className="relative">
        <div className="flex animate-[scrollLeft_35s_linear_infinite] whitespace-nowrap w-max">
          {doubled.map((item, i) => (
            <div key={i} className="flex items-center gap-3 px-10">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${item.icon} text-gold text-sm`} />
              </div>
              <span className="text-white/60 text-xs font-sans font-medium tracking-widest uppercase whitespace-nowrap">
                {item.text}
              </span>
              <span className="text-gold/30 text-sm ml-6">·</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
